import { render, staticRenderFns } from "./GtNbxx.vue?vue&type=template&id=1bfaa54a&scoped=true"
import script from "./GtNbxx.vue?vue&type=script&lang=js"
export * from "./GtNbxx.vue?vue&type=script&lang=js"
import style0 from "./GtNbxx.vue?vue&type=style&index=0&id=1bfaa54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfaa54a",
  null
  
)

export default component.exports